export default "skymp5-front/bae16a96a1830c4c1b353a00cd12b7cc.png";